// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSettingsAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { EMAIL_VALIDATION } from 'logic/data/Izenda.EmailConstants';
import { get, isEmpty } from 'lodash/fp';

export default withHandlers({
  /**
   * Cancel Change config
   */
  cancelChangeConfig: props => () => {
    const { validation: valManager, localization, store } = props;
    const { clonedEmailConfiguration: emailConfiguration, alertDetails } = store;

      return props.confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      }).then(() => {

        alertDetails.reset();
      });
  },

  /**
   * Save email config
   */
  saveConfig: props => () => {
    const {  localization, store, loader, confirmFn } = props;
    const { alertDetails } = store;

    return props
    .confirmFn('Confirmation', {
      description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
    })
    .then(function() {
       loader.startLoading();
       if(props.store.model.predictionServerStatus){
            return store.saveMLNLQSettings();
       }else{
            let correctstring = "Please validate your string before saving";
            props.store.alertDetails.set({
              message: correctstring
            });
      }

    }).then(function(nlqResult) {
      if(nlqResult.success){
        let messages = localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
        props.store.alertDetails.set({
          success: nlqResult.success,
          message: messages
        });
    }
    }).catch((error)=>{
     let messages = "There was connectivity issue while communicating with Machine learning service. Please check your connection and try again";
      store.alertDetails.set({
        message: messages
      });
    })
    .finally(loader.endLoading.bind(loader));
  },

  /**
   * Reset alert details
   */
  resetAlert: props => () => {
    return props.store.alertDetails.reset();
  }
});




// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NLQSettingsAction.js